import { Button, Fade, styled, Box, Typography, useTheme } from '@mui/material'
import { useState } from 'react'
import NotificationPic from 'assets/images/svg/common/notifications-new.svg'
import { FlexBox } from 'styleds'
import { useMessageInfo } from 'state/user/hooks'
import { chooseMark, useUnreadList } from 'services/module/message'
import { MESSAGE_TITLE, MESSAGE_TRACK_TYPE } from 'services/types/Message'
import { messageDateFormat } from 'utils/date'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from 'state/hooks'
import { useSensors } from 'hooks/useSensors'

const ModelButton = styled(Button)`
  cursor: pointer;
  outline: none;
  height: 56px;
  margin-left: 28px;
  padding: 0;
  position: relative;
  :hover {
    background: transparent !important;
  }
`

const Wrapper = styled(Fade)`
  position: absolute;
  background: ${props => props.theme.colors.background.body};
  background-image: linear-gradient(rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.12));
  top: 56px;
  right: 0;
  z-index: 99999;
  transition: all(0.5s);
  overflow-y: auto;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0) 100%), #161616;
  width: 400px;
  min-height: 608px;
  text-align: left;
`

const ImgBox = styled(Box)`
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin-right: 16px; */
  position: relative;
`

const NumLabel = styled(Box)`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: ${props => props.theme.colors.white};
  transform: scale(0.5);
  position: absolute;
  background: ${props => props.theme.colors.red[200]};
  border-radius: 50%;
  left: 24px;
  top: 10px;
`
const MList = styled(Box)`
  height: 478px;
  overflow: auto;
`
const MItem = styled(Box)`
  padding: 24px;
  position: relative;
  ::after {
    content: '';
    background: ${props => props.theme.colors.neutral[900]};
    position: absolute;
    height: 1px;
    width: 376px;
    bottom: 0;
    right: 0;
  }
  :hover {
    background: linear-gradient(
      90deg,
      ${props => props.theme.colors.neutral[900]} 0%,
      ${props => props.theme.colors.secondary} 100%
    );
  }
`
const Point = styled(Box)`
  flex-shrink: 0;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 10px;
`
const TitleTypography = styled(Typography)`
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-align: left;
`

const DateTypography = styled(Typography)`
  font-size: 14px;
  line-height: 20px;
  flex-shrink: 0;
  color: ${props => props.theme.colors.primary[400]};
`

const EventLabel = styled(Box)`
  display: inline-block;
  padding: 4px;
  background: linear-gradient(90deg, #ff7a00 0%, #ffa800 100%);
  font-weight: 500;
  font-size: 12px;
  line-height: 12px;
  margin-right: 8px;
`

const ContentTypography = styled(Typography)`
  font-size: 13px;
  line-height: 20px;
  color: ${props => props.theme.colors.primary[400]};
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-top: 6px;
  padding-left: 16px;
`
const ViewAll = styled(Box)`
  cursor: pointer;
  width: 400px;
  height: 64px;
  line-height: 64px;
  background: ${props => props.theme.colors.primary[300]};
  text-align: center;
  font-weight: 500;
  font-size: 16px;
  color: ${props => props.theme.colors.primary[400]};
`
const Mask = styled(Box)`
  position: absolute;
  width: 400px;
  left: 0;
  bottom: 64px;
  height: 64px;
  background: linear-gradient(180deg, rgba(22, 22, 22, 0) 0%, #161616 100%);
`
export default function NotificationModel() {
  const theme = useTheme()
  const { sensorsTrack } = useSensors()
  const message = useMessageInfo()
  const unreadList = useUnreadList()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [open, setOpen] = useState<boolean>(false)

  return (
    <>
      <ModelButton
        id="basic-button"
        onClick={e => {
          e.preventDefault()
        }}
        onMouseEnter={() => {
          sensorsTrack('NotificationEntranceClick', {})
          setOpen(true)
        }}
        onMouseLeave={() => setOpen(false)}
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        <ImgBox>
          <img src={NotificationPic} alt="" />
          {message.unreadNum > 0 && <NumLabel>{message.unreadNum}</NumLabel>}
        </ImgBox>
        {open && (
          <Wrapper in={open}>
            <Box>
              <FlexBox padding={'24px 24px 18px 24px'} borderBottom={`1px solid ${theme.colors.neutral[900]}`}>
                <Typography variant="body2" lineHeight="24px" fontWeight="700">
                  Inbox
                </Typography>
                <Typography fontSize="14px" fontWeight="500" color="#AFAFAF">
                  {unreadList.length} unread
                </Typography>
              </FlexBox>
              <MList>
                {unreadList &&
                  message.unreadNum > 0 &&
                  unreadList.map(el => (
                    <MItem
                      key={`message-${el.type}-${el.id}`}
                      onClick={() => {
                        chooseMark(el.id).then(res => {
                          if (res.code === 200) {
                            dispatch(updateReadMessage(1))
                          }
                        })
                        sensorsTrack('NotificationDetailClick', {
                          module_id: MESSAGE_TRACK_TYPE[el.type],
                          item_id: el.title,
                        })
                        if (el.url) {
                          window.location.href = el.url
                        }
                      }}
                    >
                      <FlexBox>
                        <Box display={'flex'} alignItems="flex-start" width="100%">
                          <Point bgcolor={theme.colors.red[200]}></Point>
                          <EventLabel>{MESSAGE_TITLE[el.type]}</EventLabel>
                          <TitleTypography>{el.title}</TitleTypography>
                        </Box>
                        <DateTypography>{messageDateFormat(el.createTime)}</DateTypography>
                      </FlexBox>
                      <ContentTypography>{el.content}</ContentTypography>
                    </MItem>
                  ))}
              </MList>

              <ViewAll
                onClick={() => {
                  sensorsTrack('SeeallClick', {})
                  navigate('/inbox')
                }}
              >
                View All
              </ViewAll>
              <Mask></Mask>
            </Box>
          </Wrapper>
        )}
      </ModelButton>
    </>
  )
}
function updateReadMessage(arg0: any): any {
  throw new Error('Function not implemented.')
}
